// Generated from Figma Design Guidelines

export const ProductLineTextToVideo = (props: React.JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M20.6496 12V8C20.6496 5.79086 18.8587 4 16.6496 4H7.34961C5.14047 4 3.34961 5.79086 3.34961 8V16C3.34961 18.2091 5.14047 20 7.34961 20H13.9996"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M19.332 16.5542C19.4929 16.8969 19.7678 17.1724 20.1104 17.3335C19.7681 17.4945 19.493 17.7695 19.332 18.1118C19.1709 17.7693 18.8954 17.4944 18.5527 17.3335C18.8957 17.1725 19.171 16.8971 19.332 16.5542Z"
      stroke="currentColor"
      strokeWidth="2.25"
    />
    <path
      d="M12.0007 8.00293V16M10.334 16.2996C11.6357 16.2996 13.6673 16.2996 13.6673 16.2996"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8 9.6696V8.50293C8 8.22679 8.22386 8.00293 8.5 8.00293H15.5C15.7761 8.00293 16 8.22679 16 8.50293V9.6696"
      stroke="currentColor"
      strokeWidth="1.5"
    />
  </svg>
);
